const staticPagesStyle = (theme) => ({
  pageRoot: {
    margin: '-8px',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#1A0F3B',
  },
  pageHeader: {
    flex: 1,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '&:before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      zIndex: 1,
      background:
        'linear-gradient(160deg, rgba(26,15,59,0.62) 0%, rgba(18,10,42,0.4) 45%, rgba(26,15,59,0.72) 100%)',
    },
  },
  contentWrap: {
    position: 'relative',
    zIndex: 2,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '110px 24px 48px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '96px 16px 40px',
    },
  },
  glassCard: {
    width: '100%',
    maxWidth: '820px',
    borderRadius: '28px',
    padding: '40px 36px 36px',
    background: 'rgba(32, 20, 72, 0.48)',
    border: '1px solid rgba(251, 250, 254, 0.22)',
    boxShadow:
      '0 24px 60px rgba(0,0,0,0.35), 0 0 40px rgba(100, 17, 237, 0.2), inset 0 1px 0 rgba(255,255,255,0.12)',
    backdropFilter: 'blur(22px)',
    WebkitBackdropFilter: 'blur(22px)',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '12%',
      right: '12%',
      height: '2px',
      background:
        'linear-gradient(90deg, transparent, rgba(118,40,255,0.95), rgba(251,250,254,0.7), rgba(118,40,255,0.95), transparent)',
      boxShadow: '0 0 18px rgba(118, 40, 255, 0.7)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '32px 20px 28px',
      borderRadius: '22px',
    },
  },
  eyebrow: {
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '2.4px',
    textTransform: 'uppercase',
    color: '#7628FF',
    marginBottom: '12px',
  },
  title: {
    fontFamily: "'Outfit', 'Poppins', sans-serif !important",
    fontSize: '2.4rem',
    fontWeight: 800,
    color: '#FBFAFE',
    letterSpacing: '-0.4px',
    lineHeight: 1.15,
    margin: '0 0 14px',
    textShadow: '0 2px 14px rgba(0,0,0,0.35)',
    '& span': {
      background: 'linear-gradient(105deg, #6411ED 0%, #7628FF 55%, #9F5CFF 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.85rem',
    },
  },
  underline: {
    width: '64px',
    height: '4px',
    borderRadius: '3px',
    marginBottom: '22px',
    background: 'linear-gradient(90deg, #6411ED, #7628FF)',
    boxShadow: '0 0 12px rgba(118, 40, 255, 0.5)',
  },
  body: {
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '15.5px',
    fontWeight: 400,
    color: 'rgba(251, 250, 254, 0.9)',
    lineHeight: 1.7,
    margin: '0 0 16px',
  },
  companyName: {
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '1.35rem',
    fontWeight: 800,
    color: '#FBFAFE',
    margin: '0 0 8px',
  },
  detailRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '14px',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '15px',
    color: 'rgba(251, 250, 254, 0.9)',
    lineHeight: 1.5,
  },
  detailIcon: {
    flexShrink: 0,
    width: '40px',
    height: '40px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(44, 25, 91, 0.55)',
    border: '1px solid rgba(118, 40, 255, 0.55)',
    boxShadow: '0 0 14px rgba(100, 17, 237, 0.35)',
    color: '#FBFAFE',
  },
  detailLabel: {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
    color: '#D7CFEB',
    marginBottom: '2px',
  },
  detailLink: {
    color: '#FBFAFE',
    textDecoration: 'none',
    fontWeight: 600,
    '&:hover': {
      color: '#7628FF',
      textDecoration: 'underline',
    },
  },
  socialLabel: {
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '1.8px',
    textTransform: 'uppercase',
    color: '#D7CFEB',
    margin: '22px 0 12px',
  },
  socialRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  },
  socialBtn: {
    width: '46px',
    height: '46px',
    borderRadius: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(18, 10, 42, 0.45)',
    border: '1px solid rgba(251, 250, 254, 0.28)',
    color: '#FBFAFE',
    transition: 'background 0.2s ease, border-color 0.2s ease, transform 0.2s ease',
    '&:hover': {
      background: 'rgba(100, 17, 237, 0.35)',
      borderColor: 'rgba(118, 40, 255, 0.65)',
      transform: 'translateY(-2px)',
    },
  },
  socialIcon: {
    fontSize: '20px',
  },
  footerTag: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '28px',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '1.8px',
    textTransform: 'uppercase',
    color: '#EBE7FB',
  },
  footerTagLine: {
    width: '42px',
    height: '3px',
    borderRadius: '2px',
    background: 'linear-gradient(90deg, #6411ED, #7628FF)',
  },
  // legacy keys for PrivacyPolicy / TermCondition
  container: {
    zIndex: 12,
    color: '#FFFFFF',
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    width: '100%',
    maxWidth: '960px',
    margin: '0 auto',
    padding: '16px 24px 32px',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '12px 16px 28px',
    },
  },
  main: {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: 3,
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },
  mainRaised: {
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow:
      '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    [theme.breakpoints.down('sm')]: {
      margin: '-48px 12px 0',
      borderRadius: '10px',
    },
  },
  description: {
    color: '#383838',
  },
  subtitle: {
    fontSize: '1.313rem',
    maxWidth: '500px',
    margin: '10px auto 0',
  },
  rtlDescription: {
    textAlign: 'right',
    color: '#383838',
    margin: '0 0 12px',
    paddingLeft: 4,
    paddingRight: 4,
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    lineHeight: 1.55,
  },
  ltrDescription: {
    textAlign: 'left',
    color: '#383838',
    margin: '0 0 12px',
    paddingLeft: 4,
    paddingRight: 4,
    maxWidth: '100%',
    boxSizing: 'border-box',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    lineHeight: 1.55,
  },
});

export default staticPagesStyle;
